/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findPrebidImportBufferEntries } from '../fn/prebid-import/find-prebid-import-buffer-entries';
import { FindPrebidImportBufferEntries$Params } from '../fn/prebid-import/find-prebid-import-buffer-entries';
import { FindPrebidImportBufferEntriesResponseDto } from '../models/find-prebid-import-buffer-entries-response-dto';
import { getPrebidImportAuctionStatistics } from '../fn/prebid-import/get-prebid-import-auction-statistics';
import { GetPrebidImportAuctionStatistics$Params } from '../fn/prebid-import/get-prebid-import-auction-statistics';
import { getPrebidImportReferences } from '../fn/prebid-import/get-prebid-import-references';
import { GetPrebidImportReferences$Params } from '../fn/prebid-import/get-prebid-import-references';
import { getPrebidImportStatus } from '../fn/prebid-import/get-prebid-import-status';
import { GetPrebidImportStatus$Params } from '../fn/prebid-import/get-prebid-import-status';
import { PrebidImportAuctionStatisticsResponseDto } from '../models/prebid-import-auction-statistics-response-dto';
import { PrebidImportReferencesDto } from '../models/prebid-import-references-dto';
import { PrebidImportStatusDto } from '../models/prebid-import-status-dto';
import { triggerPrebidImportFetch } from '../fn/prebid-import/trigger-prebid-import-fetch';
import { TriggerPrebidImportFetch$Params } from '../fn/prebid-import/trigger-prebid-import-fetch';
import { triggerPrebidImportFullRefetch } from '../fn/prebid-import/trigger-prebid-import-full-refetch';
import { TriggerPrebidImportFullRefetch$Params } from '../fn/prebid-import/trigger-prebid-import-full-refetch';
import { TriggerPrebidImportResponseDto } from '../models/trigger-prebid-import-response-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedPrebidImportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPrebidImportStatus()` */
  static readonly GetPrebidImportStatusPath = '/api/prebid-import/status';

  /**
   * Gets the state of the prebid import per source-system.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPrebidImportStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrebidImportStatus$Response(params?: GetPrebidImportStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportStatusDto>> {
    return getPrebidImportStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the state of the prebid import per source-system.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPrebidImportStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrebidImportStatus(params?: GetPrebidImportStatus$Params, context?: HttpContext): Observable<PrebidImportStatusDto> {
    return this.getPrebidImportStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidImportStatusDto>): PrebidImportStatusDto => r.body)
    );
  }

  /** Path part for operation `getPrebidImportReferences()` */
  static readonly GetPrebidImportReferencesPath = '/api/prebid-import/references';

  /**
   * Gets the auction identifiers the prebid source platforms have to report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPrebidImportReferences()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrebidImportReferences$Response(params?: GetPrebidImportReferences$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportReferencesDto>> {
    return getPrebidImportReferences(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the auction identifiers the prebid source platforms have to report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPrebidImportReferences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrebidImportReferences(params?: GetPrebidImportReferences$Params, context?: HttpContext): Observable<PrebidImportReferencesDto> {
    return this.getPrebidImportReferences$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidImportReferencesDto>): PrebidImportReferencesDto => r.body)
    );
  }

  /** Path part for operation `getPrebidImportAuctionStatistics()` */
  static readonly GetPrebidImportAuctionStatisticsPath = '/api/prebid-import/statistics';

  /**
   * Gets what one source system's prebid import produced per fetched auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPrebidImportAuctionStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrebidImportAuctionStatistics$Response(params: GetPrebidImportAuctionStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportAuctionStatisticsResponseDto>> {
    return getPrebidImportAuctionStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets what one source system's prebid import produced per fetched auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPrebidImportAuctionStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrebidImportAuctionStatistics(params: GetPrebidImportAuctionStatistics$Params, context?: HttpContext): Observable<PrebidImportAuctionStatisticsResponseDto> {
    return this.getPrebidImportAuctionStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidImportAuctionStatisticsResponseDto>): PrebidImportAuctionStatisticsResponseDto => r.body)
    );
  }

  /** Path part for operation `findPrebidImportBufferEntries()` */
  static readonly FindPrebidImportBufferEntriesPath = '/api/prebid-import/buffer';

  /**
   * Finds buffered prebids of the prebid import.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findPrebidImportBufferEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebidImportBufferEntries$Response(params: FindPrebidImportBufferEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<FindPrebidImportBufferEntriesResponseDto>> {
    return findPrebidImportBufferEntries(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds buffered prebids of the prebid import.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findPrebidImportBufferEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebidImportBufferEntries(params: FindPrebidImportBufferEntries$Params, context?: HttpContext): Observable<FindPrebidImportBufferEntriesResponseDto> {
    return this.findPrebidImportBufferEntries$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindPrebidImportBufferEntriesResponseDto>): FindPrebidImportBufferEntriesResponseDto => r.body)
    );
  }

  /** Path part for operation `triggerPrebidImportFetch()` */
  static readonly TriggerPrebidImportFetchPath = '/api/prebid-import/fetch';

  /**
   * Triggers a manual prebid import fetch.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerPrebidImportFetch()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerPrebidImportFetch$Response(params?: TriggerPrebidImportFetch$Params, context?: HttpContext): Observable<StrictHttpResponse<TriggerPrebidImportResponseDto>> {
    return triggerPrebidImportFetch(this.http, this.rootUrl, params, context);
  }

  /**
   * Triggers a manual prebid import fetch.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerPrebidImportFetch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerPrebidImportFetch(params?: TriggerPrebidImportFetch$Params, context?: HttpContext): Observable<TriggerPrebidImportResponseDto> {
    return this.triggerPrebidImportFetch$Response(params, context).pipe(
      map((r: StrictHttpResponse<TriggerPrebidImportResponseDto>): TriggerPrebidImportResponseDto => r.body)
    );
  }

  /** Path part for operation `triggerPrebidImportFullRefetch()` */
  static readonly TriggerPrebidImportFullRefetchPath = '/api/prebid-import/full-refetch';

  /**
   * Triggers a full prebid import re-fetch, discarding watermarks and buffer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerPrebidImportFullRefetch()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerPrebidImportFullRefetch$Response(params?: TriggerPrebidImportFullRefetch$Params, context?: HttpContext): Observable<StrictHttpResponse<TriggerPrebidImportResponseDto>> {
    return triggerPrebidImportFullRefetch(this.http, this.rootUrl, params, context);
  }

  /**
   * Triggers a full prebid import re-fetch, discarding watermarks and buffer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerPrebidImportFullRefetch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerPrebidImportFullRefetch(params?: TriggerPrebidImportFullRefetch$Params, context?: HttpContext): Observable<TriggerPrebidImportResponseDto> {
    return this.triggerPrebidImportFullRefetch$Response(params, context).pipe(
      map((r: StrictHttpResponse<TriggerPrebidImportResponseDto>): TriggerPrebidImportResponseDto => r.body)
    );
  }

}
